import type { IconProps } from "./icon-types";

/**
 * 테이블(행) 보기. 데이터 컬렉션을 표(행)로 표시하는 뷰 전환에서 사용
 * (DataTable ↔ DataGridView 토글 등). 가로 행 3줄 + 선두 컬럼 구분선 스트로크.
 */
export const TableViewIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path
      d="M2.5 3.5h11m-11 4.5h11m-11 4.5h11M5.5 3.5v9"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </svg>
);
